import React, { useState } from 'react';
import Matches from './Matches';
import MatchdaySettings from './MatchdaySettings';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiZap } = FiIcons;

const MatchesHub = () => {
  const [activeTab, setActiveTab] = useState('matches');

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={() => setActiveTab('matches')}
            className={`inline-flex items-center px-4 py-2 rounded-lg text-sm font-bold transition-colors ${activeTab === 'matches' ? 'bg-primary-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
          >
            <SafeIcon icon={FiCalendar} className="w-4 h-4 mr-2" /> Αγώνες
          </button>
          <button
            type="button"
            onClick={() => setActiveTab('matchday')}
            className={`inline-flex items-center px-4 py-2 rounded-lg text-sm font-bold transition-colors ${activeTab === 'matchday' ? 'bg-primary-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
          >
            <SafeIcon icon={FiZap} className="w-4 h-4 mr-2" /> Matchday Mode
          </button>
        </div>
      </div>

      {activeTab === 'matches' ? <Matches /> : <MatchdaySettings />}
    </div>
  );
};

export default MatchesHub;
